// Feature flags. Populated from server-injected window.__FEATURE_FLAGS__ (set via
// a <script> tag in index.html by the Express layer) or fall back to hardcoded defaults.
// Default: all flags OFF — features ship dark and are enabled per-environment.
const _f = (typeof window !== 'undefined' && window.__FEATURE_FLAGS__) || {};

export const SEARCH_AI_BUILDER_ENABLED = _f.SEARCH_AI_BUILDER_ENABLED === true;

// Task #240 — Intelligence Engine #1 (survival-analysis stale-lead detection).
// When true, the CRM contact list shows a per-contact "hazard of going cold"
// chip computed from the stale_lead_hazard_v1 Cox PH model artifact.
// Stays false until a model artifact is trained and reviewed. Server-side flip
// via the FEATURE_INTEL_STALE_HAZARD env var picked up at boot.
export const INTEL_STALE_HAZARD_V1 = _f.INTEL_STALE_HAZARD_V1 === true;

// Task #243 — Intelligence Engine #2 (Thompson sampling outreach optimizer).
// When true, the sequence processor overrides scheduled_at on outbound
// messages with the bandit's send-time choice. No client-side surface yet —
// this constant is reserved for the eventual admin dashboard. Server-side
// flip via the FEATURE_INTEL_OUTREACH_BANDIT env var.
export const INTEL_OUTREACH_BANDIT_V1 = _f.INTEL_OUTREACH_BANDIT_V1 === true;
